import React from "react";

const PigpenOutput: React.FC = () => {
  return <div>PigpenOutput content</div>;
};

export default PigpenOutput;
